export default "__VITE_ASSET__DJEvyPP5__"